import { render, staticRenderFns } from "./fa4.vue?vue&type=template&id=6e01d1c0&lang=pug&"
import script from "./fa4.vue?vue&type=script&lang=js&"
export * from "./fa4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports